import {Grid, Typography} from "@mui/material";
import React from "react";
import {useWelcomeAssistantContext} from "../ContextType";
import {Slider} from "../Slider";

export function Stage3() {
    const {yourName, yourMail} = useWelcomeAssistantContext();

    return (
        <Slider nr={3}>
            <Grid container justifyContent="center" direction="column" alignItems="center" rowGap={3}>
                <Grid item>
                    <Typography variant="h3">
                        Vielen Dank {yourName}!
                    </Typography>
                </Grid>
                <Grid item>
                    {yourMail &&
                        <Typography>
                            Wir haben deine Anfrage erhalten und dir zur Bestätigung eine Nachricht an {yourMail} geschickt.
                        </Typography>
                    }

                    {!yourMail &&
                        <Typography>
                            Wir haben deine Anfrage erhalten und werden uns per Telefon / WhatsApp bei dir melden.
                        </Typography>
                    }
                </Grid>
            </Grid>
        </Slider>
    );
}